export default __webpack_public_path__ + "static/UKZN-T&L-2021-AR-web-aa2e0d3ee386d4f11cb3bfa3b6e8b1ca.pdf";